import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["src"];
import logoImage from '@/assets/images/logo.svg';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VariableLogo',
    props: {
        size: {
            type: Number,
            required: true
        },
        pd: {
            type: Number,
            required: true
        },
        rounded: {
            type: Number,
            required: true
        }
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: "variable-logo",
                style: _normalizeStyle({
                    width: __props.size + 'px',
                    height: __props.size + 'px',
                    padding: __props.pd + 'px',
                    borderRadius: __props.rounded + 'px'
                })
            }, [
                _createElementVNode("img", {
                    class: "variable-logo__image",
                    src: _unref(logoImage),
                    alt: "Logo"
                }, null, 8, _hoisted_1)
            ], 4));
        };
    }
});
